import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { authIsLoadingSelector } from "../../../modules/auth/Selectors";
import Cookies from "js-cookie";
import { appReadyAction } from "../../../services/globalActions";

function LoginToken(props) {
  const token = props.match.params.token;
  console.log(props, "propsprops");
  useEffect(() => {
    if (token) {
      Cookies.set("TOKEN", token, { expires: 7 });
      window.location.href = "/dashboard";
    } else {
      window.location.href = "/auth/login";
    }
  }, [token]);

  return (
    <>
      <div></div>
    </>
  );
}

const mapStateToProps = (state) => ({
  authIsLoading: authIsLoadingSelector(state),
});

export default injectIntl(connect(mapStateToProps, {})(LoginToken));
